import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const familyMemberList = createAsyncThunk('profile/family/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'family_member',
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addFamilyMember = createAsyncThunk('profile/family/add', async (data) => {
    const bodyFormData = new FormData()

    bodyFormData.append("first_name", data?.values?.first_name)
    bodyFormData.append("last_name", data?.values?.last_name)
    bodyFormData.append("gender", data?.values?.gender)
    bodyFormData.append("username", data?.values?.username)
    bodyFormData.append("user_email", data?.values?.email)
    bodyFormData.append("user_mobile", data?.values?.mobile_number)
    bodyFormData.append("dob", data?.values?.dob ? moment(data?.values?.dob, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
    if (data?.values?.profile) {
        bodyFormData.append("user_profile", data.values.profile)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'family_member',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "profile", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateFamilyMember = createAsyncThunk('profile/family/update', async (data) => {
    const bodyFormData = new FormData()

    bodyFormData.append("member_id", data?.values?.id)
    bodyFormData.append("first_name", data?.values?.first_name)
    bodyFormData.append("last_name", data?.values?.last_name)
    bodyFormData.append("gender", data?.values?.gender)
    bodyFormData.append("username", data?.values?.username)
    bodyFormData.append("user_email", data?.values?.email)
    bodyFormData.append("user_mobile", data?.values?.mobile_number)
    bodyFormData.append("dob", data?.values?.dob ? moment(data?.values?.dob, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
    if (data?.values?.profile) {
        bodyFormData.append("user_profile", data.values.profile)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_family_member',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "profile", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delFamilyMember = createAsyncThunk('profile/family/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `family_member/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const familyMember = createSlice({
    name: 'familyMember',
    initialState: {
        list: [],
    },
    extraReducers: (builder) => {
        builder.addCase(familyMemberList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action?.payload?.data?.data || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
    }
})

export default familyMember.reducer;